import React, { useEffect } from "react";

import Modeler from "./containers/smart/camunda/modeler";
import "./theme/css/app.css";
import Provider from "./Provider";
import SendMessage from "./util/message";

function App() {
  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      window.parent.postMessage(
        { size: `${document.documentElement.scrollHeight}px` },
        "*",
      );
    });

    resizeObserver.observe(document.documentElement);

    const handleMessage = async ({ data: event }) => {
      if (event.message === "setup") {
        sessionStorage.setItem("token", event.data?.token);
        sessionStorage.setItem("tenant", event.data?.tenant);
        sessionStorage.setItem("baseUrl", event.data?.baseUrl);
        window.dispatchEvent(new Event("token_updated"));
      }
    };

    window.addEventListener("message", handleMessage);

    SendMessage({ status: "load_complete" });

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return (
    <Provider>
      <Modeler />
    </Provider>
  );
}

export default App;
